import api from "@/api";

export default {
    create(workspaceId, columnId, taskData) {
        return api.post(`/api/workspaces/${workspaceId}/columns/${columnId}/tasks`, taskData);
    },
    update(workspaceId, columnId, taskId, taskData) {
        return api.put(`/api/workspaces/${workspaceId}/columns/${columnId}/tasks/${taskId}`, taskData);
    },
    deleteById(workspaceId, columnId, taskId) {
        return api.delete(`/api/workspaces/${workspaceId}/columns/${columnId}/tasks/${taskId}`);
    },
    updateStatus(workspaceId, columnId, taskId, statusPayload) {
        return api.put(`/api/workspaces/${workspaceId}/columns/${columnId}/tasks/${taskId}/status`, statusPayload);
    },
    dongBoNguoiDung(workspaceId, columnId, taskId) {
        return api.post(`/api/workspaces/${workspaceId}/columns/${columnId}/tasks/${taskId}/dong-bo-nguoi-dung`);
    },
    thayTheNguoiDung(workspaceId, columnId, taskId) {
        return api.post(`/api/workspaces/${workspaceId}/columns/${columnId}/tasks/${taskId}/thay-the-nguoi-dung`);
    },
    markAsRead(workspaceId, columnId, taskId) {
        return api.post(`/api/workspaces/${workspaceId}/columns/${columnId}/tasks/${taskId}/mark-as-read`);
    },
    getArchived(params) {
    return api.get("/api/archived-tasks", { params });
    },
    getMentionOptions(workspaceId, columnId, taskId) {
    return api.get(`/api/workspaces/${workspaceId}/columns/${columnId}/tasks/${taskId}/mention/options`);
    },
};